import { lazy, Suspense, useEffect, useState } from "react";

const LazyToaster = lazy(() =>
	import("react-hot-toast").then(({ Toaster }) => ({ default: Toaster })),
);

const DeferredToaster = () => {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		const timer = window.setTimeout(() => setReady(true), 2500);
		return () => window.clearTimeout(timer);
	}, []);

	if (!ready) return null;

	return (
		<Suspense fallback={null}>
			<LazyToaster />
		</Suspense>
	);
};

export default DeferredToaster;
